import { render } from "./HeroiconsSolidSwitchVertical.vue?vue&type=template&id=b8a4bab4"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSwitchVertical.vue"]])

export default __exports__